import axios from "@/axios";
import router from "@/router";

const state = {
  adminData: null,
  selectedCustomer: null,
};

const getters = {
  retrieveAdmin: (state) => {
    if (state.adminData) {
      return state.adminData;
    }
  },
  retrieveSelectedCustomer: (state) => {
    if (state.selectedCustomer) {
      return state.selectedCustomer;
    }
  },
};

const actions = {
  async getAdmin({ commit }) {
    console.log("-- Getting Admin data");
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios.post("admin/get-admin", params).catch((e) => {
      console.log("-- Get Admin failure");
      console.log(e);
      return false;
    });

    if (response.data.success == true) {
      commit("setAdmin", response.data);
      if (response.data.account_type == "C1") {
        let customerAccount = Object.keys(response.data.customer_list)[0]
        commit(
          "setSelectedCustomer",
          customerAccount
        );
      } //else {
      //   if (!state.selectedCustomer) {
      //     router.push({name : "CustomerSearch"})
      //   }
       
      // }
      return true;
    } else {
      console.log("-- Get Admin False");
      return false;
    }
  },

  clearAdmin({ commit }) {
    commit("setAdmin", null);
    commit("setSelectedCustomer", null);
  },
};

const mutations = {
  setAdmin: (state, admin) => {
    state.adminData = admin;
  },

  setSelectedCustomer: (state, customer) => {
    state.selectedCustomer = customer;
  },
  
};

export default {
  state,
  getters,
  actions,
  mutations,
};
